import { UnitedStates } from "../common/utils";
import { Genders, UserDetailsType } from "../types";
import { dynamicConfig } from "./dynamicConfigs";

export const educationTypes = [
  { label: "High School", value: "high-school" },
  { label: "Undergraduate degree", value: "undergraduate-degree" },
  { label: "Master's degree", value: "masters-degree" },
  { label: "Postgraduate degree", value: "postgraduate-degree" },
];

export const genders = [
  { label: "Male", value: Genders.MALE },
  { label: "Female", value: Genders.FEMALE },
  { label: "Other", value: Genders.OTHER },
  { label: "Prefer not to say", value: Genders.NOTHING },
];

export interface AccountSetupStepPage {
  nextStepPath?: string;
}

type DetailKey = keyof UserDetailsType;

export const getRequiredKeys = (country = "", isAlphaOrBeta = false) => {
  const { flags } = dynamicConfig.features;
  const keys = [] as DetailKey[];

  if (!flags.hideBasicPageFg) {
    keys.push("firstName");
    keys.push("lastName");
    keys.push("birthDate");
  }

  if (!flags.hideGenderPageFg) {
    keys.push("gender");
  }

  if (!flags.hideStatePageFg && country === UnitedStates) {
    keys.push("region");
  }

  if (!flags.hideEducationPageFg) {
    keys.push("education");
  }

  if (!isAlphaOrBeta) {
    keys.push("interests");
    // keys.push("bio");
    // keys.push("profilePhotoUrl");
  }

  return keys;
};

const betaKeys = ["email", "interests", "profilePhotoUrl", "bio"] as const;

export const getBetaKeys = () => betaKeys;
